import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createSlots as _createSlots, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "project-show" }
const _hoisted_2 = { class: "widget-icon" }
const _hoisted_3 = { class: "widget-data" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Totaal aantal stenen", -1)
const _hoisted_5 = { class: "widget-icon" }
const _hoisted_6 = { class: "widget-data" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, "Totaal aantal uren", -1)
const _hoisted_8 = { class: "widget-icon" }
const _hoisted_9 = { class: "widget-data" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", null, "Totaal aantal stenen per uur", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("b", null, "Weet je zeker dat je deze week wilt sluiten?", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", null, "Controleer of alles correct is ingevuld voor deze week.", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", null, "Week sluiten", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("b", null, "Weet je zeker dat je deze week wilt heropenen?", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", null, "Week heropenen", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("b", null, "Weet je zeker dat je het weekrapport wilt versturen?", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", null, "Weekrapport versturen", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("b", null, "Weet je zeker dat je deze week wilt sluiten?", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", null, "Controleer of alles correct is ingevuld voor deze week.", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("b", null, "Weet je zeker dat je deze week wilt heropenen?", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", null, "Week heropenen", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("b", null, "Weet je zeker dat je het weekrapport wilt versturen?", -1)
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", null, "Bekijken", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", null, "Bewerken", -1)

import { computed, onMounted, ref } from 'vue'
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'
import { CheckOutlined, BarChartOutlined, EyeOutlined, GoldOutlined, ClockCircleOutlined, ReloadOutlined, HighlightOutlined } from '@ant-design/icons-vue'
import { notification } from 'ant-design-vue'
import { authStore } from '@/stores/auth'
import PageTitleBar from '@/components/PageTitleBar.vue'
import { ls } from '@/ls'
import { can } from '@/globalFunctions'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectTimesheets',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const loading = ref(false)
const screenWidth = computed(() => window.innerWidth)
const showClosedReports = ref(ls.get('showClosedReports') || false)

const project = ref<{ id:number, name:string, city:string }|null>(null)
const projectTimesheets = ref({
  timesheets: [],
  total: { bricks: 0, hours: 0 }
})

const activeWeekReportPanel = ref(ls.get('activeWeekReportPanel') || [])
const showNewWeekModal = ref(false)
const weekDate = ref(null)

const constructionSiteRegistrations = ref([])

const columns = ref([
  {
    title: 'Week',
    key: 'week'
  },
  {
    title: 'Ma',
    key: 'monday'
  },
  {
    title: 'Di',
    key: 'tuesday'
  },
  {
    title: 'Wo',
    key: 'wednesday'
  },
  {
    title: 'Do',
    key: 'thursday'
  },
  {
    title: 'Vr',
    key: 'friday'
  },
  {
    title: 'Status',
    key: 'status'
  },
  {
    title: 'Actie\'s',
    key: 'actions'
  }
])

const constructionSiteRegistrationColumns = ref([
  {
    title: 'Medewerker',
    key: 'constructionWorker'
  },
  {
    title: 'Actief op project',
    key: 'activeOnProject'
  },
  {
    title: 'Actie\'s',
    key: 'actions'
  }
])

const timesheets = computed(() => {
  return projectTimesheets.value.timesheets.filter((timesheet:{ id:number, status:number }) => {
    if (!showClosedReports.value) {
      return timesheet.status === 1
    }

    return true
  })
})

onMounted(() => {
  getProject()
  getTimesheets()
  getConstructionSiteRegistrations()
})

function getProject () : void {
  axios.get(process.env.VUE_APP_API_URL + '/projects/' + route.params.projectId).then((r) => {
    project.value = r.data.data
  }).catch(() => {
    notification.error({
      message: 'Fout tijdens ophalen van project details.',
      description: 'Er is iets mis gegaan. Probeer het later nog een keer.',
      duration: 0
    })
  })
}

function getTimesheets () : void {
  loading.value = true
  axios.post(process.env.VUE_APP_API_URL + '/timesheets/all', { project_id: route.params.projectId }).then((r) => {
    projectTimesheets.value = r.data
  }).catch(() => {
    notification.error({
      message: 'Fout tijdens ophalen van weekrapporten.',
      description: 'Er is iets mis gegaan. Probeer het later nog een keer.',
      duration: 0
    })
  }).finally(() => {
    loading.value = false
  })
}

function getConstructionSiteRegistrations () : void {
  loading.value = true
  axios.get(process.env.VUE_APP_API_URL + '/constructionSiteRegistrations?filter[project.id]=' + route.params.projectId + '&filter[company.id]=' + authStore().user.company_id + '&sort=created_at&limit=250').then((r) => {
    constructionSiteRegistrations.value = r.data.data
  }).catch(() => {
    notification.error({
      message: 'Fout tijdens ophalen van medewerkers.',
      description: 'Er is iets mis gegaan. Probeer het later nog een keer.',
      duration: 0
    })
  }).finally(() => {
    loading.value = false
  })
}

function addNewWeek () : void {
  axios.post(process.env.VUE_APP_API_URL + '/timesheets', { project_id: route.params.projectId, date: weekDate.value }).then((r) => {
    showNewWeekModal.value = false
    weekDate.value = null
    projectTimesheets.value = r.data
    notification.success({
      message: 'Week toegevoegd.',
      description: 'De week is succesvol toegevoegd.',
      duration: 5
    })
  }).catch(() => {
    notification.error({
      message: 'Week NIET toegevoegd.',
      description: 'De week is NIET toegevoegd. Probeer het later nog een keer.',
      duration: 0
    })
  })
}

function hideNewWeekModal () : void {
  showNewWeekModal.value = false
  weekDate.value = null
}

function closeTimesheet (id:number) : void {
  axios.get(process.env.VUE_APP_API_URL + '/timesheets/' + id + '/close').then((r) => {
    projectTimesheets.value = r.data
    notification.success({
      message: 'Week gesloten.',
      description: 'De week is succesvol gesloten.',
      duration: 5
    })
  }).catch(() => {
    notification.error({
      message: 'Week NIET gesloten.',
      description: 'De week is NIET gesloten. Probeer het later nog een keer.',
      duration: 0
    })
  })
}

function reopenTimesheet (id:number) : void {
  axios.get(process.env.VUE_APP_API_URL + '/timesheets/' + id + '/reopen').then((r) => {
    projectTimesheets.value = r.data
    notification.success({
      message: 'Week heropend.',
      description: 'De week is succesvol heropend.',
      duration: 5
    })
  }).catch(() => {
    notification.error({
      message: 'Week NIET heropend.',
      description: 'De week is NIET heropend. Probeer het later nog een keer.',
      duration: 0
    })
  })
}

function generateReport (id:number) : void {
  axios.get(process.env.VUE_APP_API_URL + '/timesheets/' + id + '/report').then(() => {
    notification.success({
      message: 'Weekrapport wordt z.s.m. verstuurd.',
      description: 'Het weekrapport wordt z.s.m. verstuurd naar de bedrijfseigenaar, dit kan enkele minuten duren.',
      duration: 8
    })
  }).catch((e) => {
    if (e.response.status === 400) {
      notification.warning({
        message: 'Weekrapport NIET verstuurd.',
        description: 'Het weekrapport is niet verstuurd omdat er niks is ingevuld voor deze week.',
        duration: 0
      })
    } else {
      notification.error({
        message: 'Weekrapport NIET verstuurd.',
        description: 'Het weekrapport is NIET verstuurd. Probeer het later nog een keer.',
        duration: 0
      })
    }
  })
}

function toggleClosedReports () : void {
  showClosedReports.value = !showClosedReports.value
  ls.set('showClosedReports', showClosedReports.value)
  axios.post(process.env.VUE_APP_API_URL + '/users/constructionSiteApp/settings', {
    settingName: 'showClosedReports',
    settingValue: showClosedReports.value
  })
}

function toggleActiveOnProject (id:number, activeOnProject:boolean) {
  axios.patch(process.env.VUE_APP_API_URL + '/constructionSiteRegistrations/' + id, { active: activeOnProject }).then(() => {
    getTimesheets()
    getConstructionSiteRegistrations()
  })
}

function setActivePanel (panels:string[]) : void {
  ls.set('activeWeekReportPanel', panels)
  activeWeekReportPanel.value = panels
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageTitleBar, null, _createSlots({
      buttons: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          style: {"float":"right","margin-left":"8px"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showNewWeekModal.value = true))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Nieuwe week toevoegen")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          style: {"float":"right"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'Dashboard' })))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Terug naar overzicht")
          ]),
          _: 1
        })
      ]),
      _: 2
    }, [
      (project.value)
        ? {
            name: "title",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(project.value.name) + " (" + _toDisplayString(project.value.reference) + ").", 1)
            ]),
            key: "0"
          }
        : {
            name: "title",
            fn: _withCtx(() => [
              _createTextVNode("Aan het laden..")
            ]),
            key: "1"
          }
    ]), 1024),
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          span: _unref(screenWidth) > 1024 ? 8 : 24
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { loading: loading.value }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(GoldOutlined), { style: { fontSize: '52px', color: '#f38929' } })
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("p", null, _toDisplayString(projectTimesheets.value.total.bricks) + " stuks", 1)
                ])
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        }, 8, ["span"]),
        _createVNode(_component_a_col, {
          span: _unref(screenWidth) > 1024 ? 8 : 24
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { loading: loading.value }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(ClockCircleOutlined), { style: { fontSize: '48px', color: '#f38929' } })
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("p", null, _toDisplayString(projectTimesheets.value.total.hours) + " uur", 1)
                ])
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        }, 8, ["span"]),
        _createVNode(_component_a_col, {
          span: _unref(screenWidth) > 1024 ? 8 : 24
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { loading: loading.value }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_unref(GoldOutlined), { style: { fontSize: '52px', color: '#f38929' } })
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("p", null, _toDisplayString(projectTimesheets.value.total.bricks_per_hour) + " stuks", 1)
                ])
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        }, 8, ["span"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              title: "Weekrapporten",
              loading: loading.value
            }, {
              extra: _withCtx(() => [
                _createTextVNode(" Toon gesloten rapporten "),
                _createVNode(_component_a_switch, {
                  style: {"margin-left":"8px"},
                  checked: showClosedReports.value,
                  onChange: toggleClosedReports
                }, null, 8, ["checked"])
              ]),
              default: _withCtx(() => [
                (_unref(screenWidth) > 1024)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_table, {
                              columns: columns.value,
                              "data-source": _unref(timesheets),
                              pagination: false
                            }, {
                              bodyCell: _withCtx(({ column, record }) => [
                                (column.key === 'week')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("h4", null, "Week " + _toDisplayString(record.year_week.toString().substring(4, 6)), 1),
                                      _createElementVNode("p", null, _toDisplayString(record.year_week.toString().substring(0, 4)), 1),
                                      _createVNode(_component_a_tag, {
                                        color: "#f38929",
                                        style: {"margin-bottom":"4px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(GoldOutlined)),
                                          _createTextVNode(" " + _toDisplayString(record.total.bricks), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _hoisted_11,
                                      _createVNode(_component_a_tag, {
                                        color: "grey",
                                        style: {"margin-bottom":"4px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ClockCircleOutlined)),
                                          _createTextVNode(" " + _toDisplayString(record.total.hours), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _hoisted_12,
                                      _createVNode(_component_a_tag, { color: "#6fb34e" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(GoldOutlined)),
                                          _createVNode(_unref(ClockCircleOutlined), { style: {"margin":"0 2px 0 4px"} }),
                                          _createTextVNode(" " + _toDisplayString(record.total.bricks_per_hour.toFixed(2)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (column.key === 'monday')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: "day",
                                      onClick: ($event: any) => (_unref(router).push({ name: 'ProjectTimesheet', params: { timesheetId: record.days[0].id } }))
                                    }, [
                                      _createElementVNode("h4", null, _toDisplayString(new Date(record.days[0].date).toLocaleDateString('nl-NL')), 1),
                                      (record.status === 1)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(record.days[0].employee_entries_count) + " / " + _toDisplayString(record.employee_count) + " ingevuld", 1))
                                        : (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(record.days[0].employee_entries_count) + " ingevuld", 1)),
                                      _createVNode(_component_a_tag, {
                                        color: "#f38929",
                                        style: {"margin-bottom":"4px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(GoldOutlined)),
                                          _createTextVNode(" " + _toDisplayString(record.days[0].bricks), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _hoisted_16,
                                      _createVNode(_component_a_tag, {
                                        color: "grey",
                                        style: {"margin-bottom":"4px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ClockCircleOutlined)),
                                          _createTextVNode(" " + _toDisplayString(record.days[0].hours), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _hoisted_17,
                                      _createVNode(_component_a_tag, { color: "#6fb34e" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(GoldOutlined)),
                                          _createVNode(_unref(ClockCircleOutlined), { style: {"margin":"0 2px 0 4px"} }),
                                          _createTextVNode(" " + _toDisplayString(record.days[0].bricks_per_hour.toFixed(2)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ], 8, _hoisted_13))
                                  : _createCommentVNode("", true),
                                (column.key === 'tuesday')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 2,
                                      class: "day",
                                      onClick: ($event: any) => (_unref(router).push({ name: 'ProjectTimesheet', params: { timesheetId: record.days[1].id } }))
                                    }, [
                                      _createElementVNode("h4", null, _toDisplayString(new Date(record.days[1].date).toLocaleDateString('nl-NL')), 1),
                                      (record.status === 1)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(record.days[1].employee_entries_count) + " / " + _toDisplayString(record.employee_count) + " ingevuld", 1))
                                        : (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(record.days[1].employee_entries_count) + " ingevuld", 1)),
                                      _createVNode(_component_a_tag, {
                                        color: "#f38929",
                                        style: {"margin-bottom":"4px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(GoldOutlined)),
                                          _createTextVNode(" " + _toDisplayString(record.days[1].bricks), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _hoisted_21,
                                      _createVNode(_component_a_tag, {
                                        color: "grey",
                                        style: {"margin-bottom":"4px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ClockCircleOutlined)),
                                          _createTextVNode(" " + _toDisplayString(record.days[1].hours), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _hoisted_22,
                                      _createVNode(_component_a_tag, { color: "#6fb34e" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(GoldOutlined)),
                                          _createVNode(_unref(ClockCircleOutlined), { style: {"margin":"0 2px 0 4px"} }),
                                          _createTextVNode(" " + _toDisplayString(record.days[1].bricks_per_hour.toFixed(2)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ], 8, _hoisted_18))
                                  : _createCommentVNode("", true),
                                (column.key === 'wednesday')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 3,
                                      class: "day",
                                      onClick: ($event: any) => (_unref(router).push({ name: 'ProjectTimesheet', params: { timesheetId: record.days[2].id } }))
                                    }, [
                                      _createElementVNode("h4", null, _toDisplayString(new Date(record.days[2].date).toLocaleDateString('nl-NL')), 1),
                                      (record.status === 1)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(record.days[2].employee_entries_count) + " / " + _toDisplayString(record.employee_count) + " ingevuld", 1))
                                        : (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(record.days[2].employee_entries_count) + " ingevuld", 1)),
                                      _createVNode(_component_a_tag, {
                                        color: "#f38929",
                                        style: {"margin-bottom":"4px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(GoldOutlined)),
                                          _createTextVNode(" " + _toDisplayString(record.days[2].bricks), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _hoisted_26,
                                      _createVNode(_component_a_tag, {
                                        color: "grey",
                                        style: {"margin-bottom":"4px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ClockCircleOutlined)),
                                          _createTextVNode(" " + _toDisplayString(record.days[2].hours), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _hoisted_27,
                                      _createVNode(_component_a_tag, { color: "#6fb34e" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(GoldOutlined)),
                                          _createVNode(_unref(ClockCircleOutlined), { style: {"margin":"0 2px 0 4px"} }),
                                          _createTextVNode(" " + _toDisplayString(record.days[2].bricks_per_hour.toFixed(2)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ], 8, _hoisted_23))
                                  : _createCommentVNode("", true),
                                (column.key === 'thursday')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 4,
                                      class: "day",
                                      onClick: ($event: any) => (_unref(router).push({ name: 'ProjectTimesheet', params: { timesheetId: record.days[3].id } }))
                                    }, [
                                      _createElementVNode("h4", null, _toDisplayString(new Date(record.days[3].date).toLocaleDateString('nl-NL')), 1),
                                      (record.status === 1)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(record.days[3].employee_entries_count) + " / " + _toDisplayString(record.employee_count) + " ingevuld", 1))
                                        : (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(record.days[3].employee_entries_count) + " ingevuld", 1)),
                                      _createVNode(_component_a_tag, {
                                        color: "#f38929",
                                        style: {"margin-bottom":"4px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(GoldOutlined)),
                                          _createTextVNode(" " + _toDisplayString(record.days[3].bricks), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _hoisted_31,
                                      _createVNode(_component_a_tag, {
                                        color: "grey",
                                        style: {"margin-bottom":"4px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ClockCircleOutlined)),
                                          _createTextVNode(" " + _toDisplayString(record.days[3].hours), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _hoisted_32,
                                      _createVNode(_component_a_tag, { color: "#6fb34e" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(GoldOutlined)),
                                          _createVNode(_unref(ClockCircleOutlined), { style: {"margin":"0 2px 0 4px"} }),
                                          _createTextVNode(" " + _toDisplayString(record.days[3].bricks_per_hour.toFixed(2)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ], 8, _hoisted_28))
                                  : _createCommentVNode("", true),
                                (column.key === 'friday')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 5,
                                      class: "day",
                                      onClick: ($event: any) => (_unref(router).push({ name: 'ProjectTimesheet', params: { timesheetId: record.days[4].id } }))
                                    }, [
                                      _createElementVNode("h4", null, _toDisplayString(new Date(record.days[4].date).toLocaleDateString('nl-NL')), 1),
                                      (record.status === 1)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(record.days[4].employee_entries_count) + " / " + _toDisplayString(record.employee_count) + " ingevuld", 1))
                                        : (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(record.days[4].employee_entries_count) + " ingevuld", 1)),
                                      _createVNode(_component_a_tag, {
                                        color: "#f38929",
                                        style: {"margin-bottom":"4px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(GoldOutlined)),
                                          _createTextVNode(" " + _toDisplayString(record.days[4].bricks), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _hoisted_36,
                                      _createVNode(_component_a_tag, {
                                        color: "grey",
                                        style: {"margin-bottom":"4px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ClockCircleOutlined)),
                                          _createTextVNode(" " + _toDisplayString(record.days[4].hours), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _hoisted_37,
                                      _createVNode(_component_a_tag, { color: "#6fb34e" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(GoldOutlined)),
                                          _createVNode(_unref(ClockCircleOutlined), { style: {"margin":"0 2px 0 4px"} }),
                                          _createTextVNode(" " + _toDisplayString(record.days[4].bricks_per_hour.toFixed(2)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ], 8, _hoisted_33))
                                  : _createCommentVNode("", true),
                                (column.key === 'status')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                      (record.status === 1)
                                        ? (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 0,
                                            color: "#6fb34e"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Open")
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 1,
                                            color: "grey"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Gesloten")
                                            ]),
                                            _: 1
                                          }))
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (column.key === 'actions')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                      (record.status === 1)
                                        ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                                            key: 0,
                                            placement: "bottomRight",
                                            "ok-text": "Ja",
                                            "cancel-text": "Nee",
                                            onConfirm: ($event: any) => (closeTimesheet(record.days[0].id))
                                          }, {
                                            title: _withCtx(() => [
                                              _hoisted_38,
                                              _hoisted_39,
                                              _hoisted_40
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_tooltip, { placement: "topRight" }, {
                                                title: _withCtx(() => [
                                                  _hoisted_41
                                                ]),
                                                default: _withCtx(() => [
                                                  _createVNode(_component_a_button, {
                                                    size: "small",
                                                    style: {"margin-right":"8px"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(CheckOutlined))
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["onConfirm"]))
                                        : _createCommentVNode("", true),
                                      (record.status === 2 && _unref(authStore)().user.roleNames.includes('external_company_owner'))
                                        ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                                            key: 1,
                                            placement: "bottomRight",
                                            "ok-text": "Ja",
                                            "cancel-text": "Nee",
                                            onConfirm: ($event: any) => (reopenTimesheet(record.days[0].id))
                                          }, {
                                            title: _withCtx(() => [
                                              _hoisted_42,
                                              _hoisted_43
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_tooltip, { placement: "topRight" }, {
                                                title: _withCtx(() => [
                                                  _hoisted_44
                                                ]),
                                                default: _withCtx(() => [
                                                  _createVNode(_component_a_button, {
                                                    size: "small",
                                                    style: {"margin-right":"8px"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(ReloadOutlined))
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["onConfirm"]))
                                        : _createCommentVNode("", true),
                                      (_unref(authStore)().user.roleNames.includes('external_company_owner'))
                                        ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                                            key: 2,
                                            placement: "bottomRight",
                                            "ok-text": "Ja",
                                            "cancel-text": "Nee",
                                            onConfirm: ($event: any) => (generateReport(record.days[0].id))
                                          }, {
                                            title: _withCtx(() => [
                                              _hoisted_45
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_tooltip, { placement: "topRight" }, {
                                                title: _withCtx(() => [
                                                  _hoisted_46
                                                ]),
                                                default: _withCtx(() => [
                                                  _createVNode(_component_a_button, { size: "small" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(BarChartOutlined))
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["onConfirm"]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["columns", "data-source"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_collapse, {
                              bordered: false,
                              activeKey: activeWeekReportPanel.value,
                              onChange: setActivePanel
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timesheets), (timesheet) => {
                                  return (_openBlock(), _createBlock(_component_a_collapse_panel, {
                                    class: "collapse-panel",
                                    header: `Week ${timesheet.year_week.toString().substring(4, 6)} - ${timesheet.year_week.toString().substring(0, 4)}`,
                                    key: timesheet.year_week
                                  }, {
                                    extra: _withCtx(() => [
                                      (timesheet.days[0].status === 1)
                                        ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                                            key: 0,
                                            placement: "bottomRight",
                                            "ok-text": "Ja",
                                            "cancel-text": "Nee",
                                            onConfirm: ($event: any) => (closeTimesheet(timesheet.days[0].id))
                                          }, {
                                            title: _withCtx(() => [
                                              _hoisted_47,
                                              _hoisted_48,
                                              _hoisted_49
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_button, {
                                                size: "small",
                                                style: {"margin-right":"8px"},
                                                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CheckOutlined))
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["onConfirm"]))
                                        : _createCommentVNode("", true),
                                      (timesheet.days[0].status === 2 && _unref(authStore)().user.roleNames.includes('external_company_owner'))
                                        ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                                            key: 1,
                                            placement: "bottomRight",
                                            "ok-text": "Ja",
                                            "cancel-text": "Nee",
                                            onConfirm: ($event: any) => (reopenTimesheet(timesheet.days[0].id))
                                          }, {
                                            title: _withCtx(() => [
                                              _hoisted_50,
                                              _hoisted_51
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_tooltip, { placement: "topRight" }, {
                                                title: _withCtx(() => [
                                                  _hoisted_52
                                                ]),
                                                default: _withCtx(() => [
                                                  _createVNode(_component_a_button, {
                                                    size: "small",
                                                    style: {"margin-right":"8px"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(ReloadOutlined))
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["onConfirm"]))
                                        : _createCommentVNode("", true),
                                      (_unref(authStore)().user.roleNames.includes('external_company_owner'))
                                        ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                                            key: 2,
                                            placement: "bottomRight",
                                            "ok-text": "Ja",
                                            "cancel-text": "Nee",
                                            onConfirm: ($event: any) => (generateReport(timesheet.days[0].id))
                                          }, {
                                            title: _withCtx(() => [
                                              _hoisted_53
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_button, {
                                                size: "small",
                                                style: {"margin-right":"8px"},
                                                onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(BarChartOutlined))
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["onConfirm"]))
                                        : _createCommentVNode("", true),
                                      (timesheet.status === 1)
                                        ? (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 3,
                                            color: "#6fb34e"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Open")
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 4,
                                            color: "grey"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Gesloten")
                                            ]),
                                            _: 1
                                          }))
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_tag, { color: "#f38929" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(GoldOutlined)),
                                          _createTextVNode(" " + _toDisplayString(timesheet.total.bricks), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_a_tag, { color: "grey" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ClockCircleOutlined)),
                                          _createTextVNode(" " + _toDisplayString(timesheet.total.hours), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_a_tag, { color: "#6fb34e" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(GoldOutlined)),
                                          _createVNode(_unref(ClockCircleOutlined), { style: {"margin":"0 2px 0 4px"} }),
                                          _createTextVNode(" " + _toDisplayString(timesheet.total.bricks_per_hour.toFixed(2)), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_a_divider, { style: { margin: '24px 0 0 0' } }),
                                      _createVNode(_component_a_list, {
                                        "item-layout": "horizontal",
                                        "data-source": timesheet.days
                                      }, {
                                        renderItem: _withCtx(({ item }) => [
                                          _createVNode(_component_a_list_item, null, {
                                            actions: _withCtx(() => [
                                              _createVNode(_component_a_button, {
                                                size: "small",
                                                onClick: ($event: any) => (_unref(router).push({ name: 'ProjectTimesheet', params: { timesheetId: item.id } }))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(EyeOutlined))
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"])
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_list_item_meta, null, {
                                                title: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(new Date(item.date).toLocaleDateString('nl-NL', { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric'})), 1)
                                                ]),
                                                description: _withCtx(() => [
                                                  (item.status === 1)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_54, _toDisplayString(item.employee_entries_count) + " / " + _toDisplayString(timesheet.employee_count) + " ingevuld.", 1))
                                                    : (_openBlock(), _createElementBlock("p", _hoisted_55, _toDisplayString(item.employee_entries_count) + " ingevuld.", 1)),
                                                  _createVNode(_component_a_tag, { color: "#f38929" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(GoldOutlined)),
                                                      _createTextVNode(" " + _toDisplayString(item.bricks), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_a_tag, { color: "grey" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(ClockCircleOutlined)),
                                                      _createTextVNode(" " + _toDisplayString(item.hours), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_a_tag, { color: "#6fb34e" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(GoldOutlined)),
                                                      _createVNode(_unref(ClockCircleOutlined), { style: {"margin":"0 2px 0 4px"} }),
                                                      _createTextVNode(" " + _toDisplayString(item.bricks_per_hour.toFixed(2)), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["data-source"])
                                    ]),
                                    _: 2
                                  }, 1032, ["header"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["activeKey"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_unref(authStore)().user.roleNames.includes('external_company_owner'))
      ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_card, {
                  title: "Medewerkers op project",
                  loading: loading.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_table, {
                      columns: constructionSiteRegistrationColumns.value,
                      "data-source": constructionSiteRegistrations.value,
                      pagination: false
                    }, {
                      bodyCell: _withCtx(({ column, record }) => [
                        (column.key === 'constructionWorker')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(record.construction_worker.firstname) + " " + _toDisplayString(record.construction_worker.lastname), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (column.key === 'activeOnProject')
                          ? (_openBlock(), _createBlock(_component_a_switch, {
                              key: 1,
                              checked: record.active,
                              "onUpdate:checked": ($event: any) => ((record.active) = $event),
                              onChange: ($event: any) => (toggleActiveOnProject(record.id, record.active))
                            }, null, 8, ["checked", "onUpdate:checked", "onChange"]))
                          : _createCommentVNode("", true),
                        (column.key === 'actions')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              (_unref(can)('construction_workers.view'))
                                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                    key: 0,
                                    placement: "top"
                                  }, {
                                    title: _withCtx(() => [
                                      _hoisted_56
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_button, {
                                        class: "listview-action",
                                        size: "small",
                                        onClick: _withModifiers(($event: any) => (_unref(router).push({ name: 'ConstructionWorkerShow', params: { constructionWorkerId: record.id } })), ["stop"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(EyeOutlined))
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (_unref(can)('construction_workers.edit'))
                                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                    key: 1,
                                    placement: "top"
                                  }, {
                                    title: _withCtx(() => [
                                      _hoisted_57
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_button, {
                                        class: "listview-action",
                                        size: "small",
                                        onClick: _withModifiers(($event: any) => (_unref(router).push({ name: 'ConstructionWorkerEdit', params: { constructionWorkerId: record.id } })), ["stop"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(HighlightOutlined))
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["columns", "data-source"])
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      title: "Nieuw weekrapport toevoegen",
      "ok-text": "Toevoegen",
      visible: showNewWeekModal.value,
      onOk: addNewWeek,
      onCancel: hideNewWeekModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_date_picker, {
          format: "DD-MM-YYYY",
          picker: "week",
          value: weekDate.value,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((weekDate).value = $event))
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})